module.exports = __webpack_public_path__ + "media/components/Header/defaultLogo-85f02649fe580566ed1a1bf45fb1241e.png";